// components/ContactButton.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle, Clock, Shield } from 'lucide-react';

const ContactButton = ({ 
 className = "",     // אפשרות להוסיף classes
}) => {
 return (
   <div className={`text-center mb-12 ${className}`}>
     <div className="mt-8 bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto">
       <h3 className="text-xl font-semibold text-gray-800 mb-3">
         צריכים עזרה משפטית?
       </h3>
       <p className="text-gray-600 mb-4">
         השאירו פרטים לייעוץ ראשוני ללא התחייבות
       </p>
       <Link 
         to="/contact" 
         className="inline-flex items-center px-8 py-4 text-lg font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-700 transition-colors duration-300 shadow-lg hover:shadow-xl group gap-2"
       >
         <span>השאירו פרטים לייעוץ ראשוני</span>
         <ArrowLeft className="w-5 h-5 transform transition-transform group-hover:-translate-x-1" />
       </Link>
       <div className="mt-4 flex items-center justify-center gap-4 text-sm text-gray-500">
         <div className="flex items-center gap-1">
           <CheckCircle className="w-4 h-4 text-green-500" />
           <span>ללא עלות</span>
         </div>
         <div className="flex items-center gap-1">
           <Clock className="w-4 h-4 text-blue-500" />
           <span>מענה מהיר</span>
         </div>
         <div className="flex items-center gap-1">
           <Shield className="w-4 h-4 text-purple-500" />
           <span>דיסקרטיות מלאה</span>
         </div>
       </div>
     </div>
   </div>
 );
};

export default ContactButton;